"use client";

import { FormProvider, useWvcForm } from "@/integrations/forms/FormProvider";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Form, FormControl, FormField, FormItem, FormLabel, FormMessage } from "@/components/ui/form";
import { Loader } from "lucide-react";
const directoryEntries = [{
  label: "STANDORT",
  value: "Bachstr. 33, 73630 Remshalden"
}, {
  label: "TELEFON",
  value: "0171 5747818"
}, {
  label: "KONTAKT",
  value: "info@naber-conduct.com"
}, {
  label: "BÜROZEITEN",
  value: "Montag bis Samstag, 8:30 — 18 Uhr"
}, {
  label: "GESCHLOSSEN",
  value: "Sonntag"
}];
function ReachOutForm() {
  const {
    isSubmitting,
    isSubmitted,
    submitError,
    successMessage,
    handleSubmit,
    resetForm,
    control
  } = useWvcForm();
  if (isSubmitted && !submitError) {
    return <div className="border-t border-b border-[var(--border)] py-12">
        <p className="font-mono text-xs uppercase tracking-[0.18em] text-[var(--muted-foreground)] mb-4">
          N° — ANFRAGE ERHALTEN
        </p>
        <p className="text-foreground text-xl font-light leading-snug mb-8">
          {successMessage}
        </p>
        <Button onClick={resetForm} variant="outline" className="border border-foreground bg-transparent text-foreground hover:bg-transparent hover:border-[var(--chart-1)] px-9 py-5 h-auto font-light tracking-[0.04em]">
          Weitere Anfrage senden
        </Button>
      </div>;
  }
  return <Form onSubmit={handleSubmit} className="space-y-10">
      <FormField control={control} name="parent_name" rules={{
      required: "Name ist erforderlich"
    }} render={({
      field
    }) => <FormItem className="grid gap-3">
            <FormLabel className="font-mono text-[11px] uppercase tracking-[0.18em] text-[var(--muted-foreground)] font-normal">
              Ihr Name
            </FormLabel>
            <FormControl>
              <Input placeholder="z.B. Max Mustermann" {...field} className="border-0 border-b border-[var(--border)] bg-transparent px-0 py-4 h-auto text-base text-foreground focus-visible:ring-0 focus-visible:border-foreground placeholder:text-[var(--muted-foreground)]/50" />
            </FormControl>
            <FormMessage />
          </FormItem>} />

      <FormField control={control} name="child_name" render={({
      field
    }) => <FormItem className="grid gap-3">
            <FormLabel className="font-mono text-[11px] uppercase tracking-[0.18em] text-[var(--muted-foreground)] font-normal">
              Objektart
            </FormLabel>
            <FormControl>
              <Input placeholder="z.B. Einfamilienhaus" {...field} className="border-0 border-b border-[var(--border)] bg-transparent px-0 py-4 h-auto text-base text-foreground focus-visible:ring-0 focus-visible:border-foreground placeholder:text-[var(--muted-foreground)]/50" />
            </FormControl>
            <FormMessage />
          </FormItem>} />

      <FormField control={control} name="email" rules={{
      required: "E-Mail ist erforderlich",
      pattern: {
        value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
        message: "Bitte geben Sie eine gültige E-Mail ein"
      }
    }} render={({
      field
    }) => <FormItem className="grid gap-3">
            <FormLabel className="font-mono text-[11px] uppercase tracking-[0.18em] text-[var(--muted-foreground)] font-normal">
              E-Mail Adresse
            </FormLabel>
            <FormControl>
              <Input type="email" placeholder="kontakt@beispiel.de" {...field} className="border-0 border-b border-[var(--border)] bg-transparent px-0 py-4 h-auto text-base text-foreground focus-visible:ring-0 focus-visible:border-foreground placeholder:text-[var(--muted-foreground)]/50" />
            </FormControl>
            <FormMessage />
          </FormItem>} />

      <FormField control={control} name="phone" render={({
      field
    }) => <FormItem className="grid gap-3">
            <FormLabel className="font-mono text-[11px] uppercase tracking-[0.18em] text-[var(--muted-foreground)] font-normal">
              Telefonnummer
            </FormLabel>
            <FormControl>
              <Input type="tel" placeholder="+49 711 123456" {...field} className="border-0 border-b border-[var(--border)] bg-transparent px-0 py-4 h-auto text-base text-foreground focus-visible:ring-0 focus-visible:border-foreground placeholder:text-[var(--muted-foreground)]/50" />
            </FormControl>
            <FormMessage />
          </FormItem>} />

      <FormField control={control} name="message" rules={{
      required: "Bitte beschreiben Sie Ihr Anliegen",
      minLength: {
        value: 10,
        message: "Nachricht muss mindestens 10 Zeichen lang sein"
      },
      maxLength: {
        value: 1000,
        message: "Nachricht darf maximal 1000 Zeichen lang sein"
      }
    }} render={({
      field
    }) => <FormItem className="grid gap-3">
            <FormLabel className="font-mono text-[11px] uppercase tracking-[0.18em] text-[var(--muted-foreground)] font-normal">
              Anliegen
            </FormLabel>
            <FormControl>
              <Textarea rows={4} placeholder="Beschreiben Sie Ihr Projekt..." {...field} className="border-0 border-b border-[var(--border)] bg-transparent px-0 py-4 min-h-0 text-base text-foreground resize-none focus-visible:ring-0 focus-visible:border-foreground placeholder:text-[var(--muted-foreground)]/50" />
            </FormControl>
            <FormMessage />
          </FormItem>} />

      {submitError && <div className="border-t border-b border-[var(--destructive)] py-4">
          <p className="font-mono text-xs uppercase tracking-[0.18em] text-[var(--destructive)]">
            {submitError}
          </p>
        </div>}

      <div className="pt-4">
        <Button type="submit" disabled={isSubmitting} className="bg-foreground text-background hover:bg-[var(--muted-foreground)] px-9 py-5 h-auto text-base font-light tracking-[0.04em] w-full sm:w-auto">
          {isSubmitting ? <>
              <Loader className="animate-spin mr-2 size-4" />
              Wird gesendet
            </> : "Anfrage senden"}
        </Button>
        <p className="mt-6 font-mono text-[11px] uppercase tracking-[0.18em] text-[var(--muted-foreground)]">
          Wir antworten innerhalb eines Werktages · Stuttgart Zeit
        </p>
      </div>
    </Form>;
}
export default function Planning() {
  return <section data-section-id="1613" id="lassen-sie-uns-planen" className="bg-background py-24 md:py-32 lg:py-44 border-t border-b border-[var(--border)] overflow-hidden">
      <div className="max-w-[1440px] mx-auto px-6 md:px-16 lg:px-24">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-y-16 lg:gap-x-8">
          <div className="lg:col-span-5 relative">
            <div className="lg:sticky lg:top-32">
              <p className="font-mono text-xs uppercase tracking-[0.18em] text-[var(--muted-foreground)]">
                N° 01 — KONTAKT
              </p>

              <div className="relative mt-14">
                <span aria-hidden="true" className="pointer-events-none absolute -top-12 right-0 select-none font-light text-[14rem] md:text-[18rem] lg:text-[22vw] leading-none text-[var(--border)]/30" style={{
                WebkitTextStroke: "1px var(--border)",
                color: "transparent"
              }}>
                  01
                </span>
                <h2 className="font-default relative text-foreground font-extralight leading-[1.02] tracking-tight text-[clamp(2.25rem,4.8vw,4.75rem)]">
                  Planen oder <em className="italic font-extralight">besuchen</em>.
                </h2>
              </div>

              <div className="mt-16 border-t border-[var(--border)]">
                {directoryEntries.map((entry, i) => <div key={i} data-index={i} className="grid grid-cols-12 gap-4 py-8 border-b border-[var(--border)]">
                    <p className="col-span-12 sm:col-span-4 font-mono text-[11px] uppercase tracking-[0.18em] text-[var(--muted-foreground)] pt-1">
                      {entry.label}
                    </p>
                    <p className="col-span-12 sm:col-span-8 font-default font-light text-foreground text-[clamp(1.125rem,1.4vw,1.375rem)] leading-snug">
                      {entry.value}
                    </p>
                  </div>)}
              </div>

              <p className="mt-12 font-mono text-[11px] uppercase tracking-[0.18em] text-[var(--muted-foreground)]">
                PLATE 09 / STUTTGART 48.7758° N, 9.1829° E
              </p>
            </div>
          </div>

          <div className="lg:col-span-7 lg:pl-8 xl:pl-16">
            <FormProvider formKey="plan_form_contact" formId="plan_form_contact" sectionName="reach-out" defaultValues={{
            parent_name: "",
            child_name: "",
            email: "",
            phone: "",
            message: ""
          }} validationRules={{
            parent_name: {
              required: true
            },
            email: {
              required: true,
              pattern: "email"
            },
            phone: {
              pattern: "phone"
            },
            message: {
              required: true,
              minLength: 10,
              maxLength: 1000
            }
          }} submitText="Anfrage senden" successMessage="Vielen Dank. Wir werden innerhalb eines Werktages antworten." errorMessage="Ihre Anfrage konnte nicht gesendet werden. Bitte versuchen Sie es erneut.">
              <ReachOutForm />
            </FormProvider>
          </div>
        </div>
      </div>
    </section>;
}